import "../styles/Footer.css";
import logo from "../assets/logo.png";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__top">
        <img className="footer__logo" src={logo} alt="My Car Kenya logo" />
        <ul>
            <h1 className="footer__title" >Marketplace</h1>
            <li><a href="https://mycarapp.co.ke/inventory">Browse Cars</a></li>
            <li><a href="https://mycarapp.co.ke/inventory">Locally Used</a></li>
            <li><a href="https://mycarapp.co.ke/inventory">Imports</a></li>
            <li><a href="https://mycarapp.co.ke/inventory">Brand New</a></li>
            <li><a href="https://mycarapp.co.ke/financing">Financing</a></li>
        </ul>
        <ul>
            <h1 className="footer__title" >Parts & Accessories</h1>
            <li><a href="https://mycarapp.co.ke/accessories">Browse accessories</a></li>
            <li><a href="https://mycarapp.co.ke/parts">Spare parts</a></li>
            <li><a href="https://mycarapp.co.ke/car-hire">Car hire</a></li>
        </ul>
        <ul>
            <h1 className="footer__title" >Company</h1>
            <li><a href="https://mycarapp.co.ke/about">About Us</a></li>
            <li><a href="https://mycarapp.co.ke/contact">Contact</a></li>
            <li><a href="https://mycarapp.co.ke/buying">Buying guide</a></li>
            <li><a href="https://mycarapp.co.ke/selling">Selling guide</a></li>
        </ul>
       
      </div>
      <div className="footer__bottom">
     <p className="text-center ">
        &copy; {new Date().getFullYear()} My Car Kenya. All rights reserved.
      </p>
      <ul>
        <li><a href="/terms">Terms</a></li> |
        <li><a href="/privacy">Privacy</a></li> |
      </ul>
      </div>
      
    </footer>
  );
}